<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.95 12.95a7 7 0 11-9.9-9.9 7 7 0 019.9 9.9zM4.846 8.025a2.383 2.383 0 012.624.505 3.883 3.883 0 004.275.824l.861-.37a.75.75 0 10-.59-1.378l-.862.369A2.383 2.383 0 018.53 7.47a3.883 3.883 0 00-4.275-.824l-.861.37a.75.75 0 00.59 1.378l.862-.369z"
    fill="currentColor"
  />
</svg>
